import { isUndefined } from './utils';
import { Section, Item, Form, Visibility } from '../types/common-types';
import { TableType } from '../components/common/table';

export function itemShouldHaveValue(item: Item) {
  const ITEMS_WITH_NO_VALUE = [
    'button',
    'label',
    'link',
    'image',
    'table',
    'tableV1',
    'list',
    'divider',
    'image',
    'loanInfo',
  ];
  let withValue = true;
  const { class: clazz } = item;
  if (ITEMS_WITH_NO_VALUE.includes(clazz)) {
    withValue = false;
  } else if (clazz === 'tableV1' && item.type !== TableType.Radio) {
    withValue = false;
  }

  return withValue;
}

export function getSectionItems(section: Section): Item[] {
  const header = section.header || [];
  const content = section.content || [];
  const footer = section.footer || [];
  return header.concat(content, footer);
}

export function isVisible(v?: Visibility) {
  return v === Visibility.Visible || !v;
}

function hasValue(v?: string | { [key: string]: string }) {
  if (typeof v === 'object') {
    return Object.keys(v).every(key => v[key] && v[key].length);
  }
  return !isUndefined(v);
}

export function getFormData(form: Form) {
  const formItems = form.sections
    .filter(sec => isVisible(sec.visibility))
    .map(i => getSectionItems(i))
    .reduce((acc, i) => acc.concat(i), [])
    .filter(
      i =>
        itemShouldHaveValue(i) && isVisible(i.visibility) && hasValue(i.value)
    );
  return formItems.reduce((acc, i) => ({ ...acc, [i.id]: i.value }), {});
}

export function stripHtml(str: string) {
  const tagsToReplace: { [key: string]: string } = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
  };
  return str
    .replace(/[&<>]/g, tag => tagsToReplace[tag] || tag)
    .replace('"', '&quot;')
    .replace(/\&amp\;euro\;/g, '&euro;'); // eslint-disable-line no-useless-escape
}

export function bbCodeToHtml(str = '') {
  if (typeof str !== 'string') return str;
  let text = stripHtml(str);
  const rB = /\[b\](.*?)\[\/b\]/gi;
  const rI = /\[i\](.*?)\[\/i\]/gi;
  const rU = /\[u\](.*?)\[\/u\]/gi;
  const rUrl = /\[url="?(.*?)"?\](.*?)\[\/url\]/gi;
  const rIUrl = /\[iurl="?(.*?)"?\](.*?)\[\/iurl\]/gi;
  const rBr = /\[br\]/gi;
  const rDiv = /\[div\](.*?)\[\/div\]/gi;
  const rSize = /\[size="?(.*?)"?\](.*?)\[\/size\]/gi;
  const rColor = /\[color="?(.*?)"?\](.*?)\[\/color\]/gi;
  const rBg = /\[bg="?(.*?)"?\](.*?)\[\/bg\]/gi;
  const rUl = /\[ul\](.*?)\[\/ul\]/gi;
  const rLi = /\[\*\](.*?)\[\/\*\]/gi;
  text = text
    .replace(rB, '<b>$1</b>')
    .replace(rI, '<i>$1</i>')
    .replace(rU, '<u>$1</u>')
    .replace(
      rUrl,
      '<a href="$1" target="_blank" rel="noopener noreferrer">$2</a>'
    )
    .replace(rIUrl, '<a href="$1">$2</a>')
    .replace(rBr, '<br/>')
    .replace(rDiv, '<div>$1</div>')
    .replace(rUl, '<ul>$1</ul>')
    .replace(rLi, '<li>$1</li>')
    .replace(rSize, '<span style="font-size:$1px">$2</span>')
    .replace(rColor, '<span style="color:$1">$2</span>')
    .replace(rBg, '<span style="background-color:$1">$2</span>');

  return text;
}
